var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, html, LitElement, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { BoostButton } from '../components/common/BoostButton';
import { MembersignupAPI, } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { isErrorHTTP } from 'boost-api/APIRestClient';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import moment from 'moment';
import { CerumLoading } from 'common-uicomponents/CerumLoading';
import { styleMap } from 'lit/directives/style-map.js';
import { WeekDay } from 'cerum-work-schedule-data/CerumWorkScheduleTaskHelper';
import { BoostPortalChooseDepartment } from '../components/BoostPortalChooseDepartment';
import { vaadinSelectRendererCallbackWrapper } from 'badphraim/ui/vaadinHtmlRendererWrapper';
import { CerumItemTag, CerumItemTagType } from 'cerumx-shared/CerumItemTag';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { BoostPortalParamsHandler } from '../helpers/BoostPortalParamsHandler';
import { Popover } from '@vaadin/popover';
import { popoverRenderer } from '@vaadin/popover/lit';
let BoostPortalClassesView = class BoostPortalClassesView extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.currentMoment = moment();
        this.portalClasses = [];
        this.isLoading = false;
        this.selectedFilters = [];
        this.isMobileView = false;
        this.availableDepartments = [];
        this.hideHeaderInformation = false;
        this.popoverOpened = false;
        this.daysOfWeek = [
            { day: WeekDay.MONDAY, groupedClasses: [] },
            { day: WeekDay.TUESDAY, groupedClasses: [] },
            { day: WeekDay.WEDNESDAY, groupedClasses: [] },
            { day: WeekDay.THURSDAY, groupedClasses: [] },
            { day: WeekDay.FRIDAY, groupedClasses: [] },
            { day: WeekDay.SATURDAY, groupedClasses: [] },
            { day: WeekDay.SUNDAY, groupedClasses: [] },
        ];
        this._hasLoadedSettings = false;
    }
    static get is() {
        return 'boost-portal-classes-view';
    }
    static get styles() {
        return css `
            :host {
                width: 100%;
                color: #262626;
                padding: 0rem 1rem;
            }

            .exercise-class-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-radius: 0px 0px 10px 10px;
            }

            .date-selection-container {
                display: grid;
                flex-direction: column;
                justify-content: space-between;
                grid-template-columns: 1fr auto 1fr;
                gap: 1.5rem;
                padding-bottom: 1rem;
                align-items: end;
                padding: 1rem 3rem 1rem 3rem;
                border-radius: 10px 10px 0px 0px;
                margin-bottom: 2px;
            }

            h1 {
                text-align: center;
            }

            .schedule {
                display: grid;
                grid-template-columns: repeat(7, minmax(180px, 1fr));
                flex-flow: wrap;
                gap: 10px;
                padding: 2rem;
                padding-top: 1rem;
            }

            .day-header {
                font-size: 16px;
                text-align: center;
                padding: 10px;
                background-color: white;
                border-radius: 8px;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
            }

            .day-column {
                gap: 0.5rem;
                display: flex;
                flex-direction: column;
            }

            .class-title {
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                align-items: center;
                padding: 3px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                gap: 6px;
            }

            .class-details {
                font-size: 0.8em;
                color: #666;
            }

            .class-card {
                background-color: white;
                padding: 6px;
                border-radius: 8px;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
            }

            .property-container {
                display: flex;
                max-width: 100%;
                gap: 2px;
                justify-content: start;
                flex-flow: wrap;
            }

            .filter-badge {
                margin: 4px;
            }

            cerum-badge {
                cursor: pointer;
                font-size: 14px;
            }

            .selected-property {
                --cerum-badge-background-color: var(--portalCardBackground, #263651);
                --cerum-badge-color: var(--portalCardForeground, #fafafa);
            }

            .schedule:has(cerum-loading) {
                display: flex;
                justify-content: center;
            }

            .current-day-button::first-letter {
                text-transform: capitalize;
            }

            boost-portal-choose-department {
                --boost-portal-choose-department-selection-margin: 0px;
            }

            cerum-form-label {
                --lumo-font-size-m: 14px;
            }

            .date-selection-inner-container {
                display: flex;
                gap: 1rem;
                justify-self: end;
                align-items: flex-end;
            }

            vaadin-select {
                padding: 0;
                width: 100%;
            }

            .options-container {
                display: flex;
                flex-direction: column;
                gap: 3px;
                align-items: center;
                justify-self: center;
            }

            .toggle-button-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                gap: 1rem;
            }

            @media only screen and (max-width: 1800px) {
                .class-title p:first-child {
                    font-size: 16px !important;
                }

                .class-title p:nth-child(2) {
                    font-size: 14px !important;
                }
            }

            @media only screen and (max-width: 1600px) {
                .class-title p:first-child {
                    font-size: 14px !important;
                }

                .class-title p:nth-child(2) {
                    font-size: 12px !important;
                }
            }

            @media only screen and (max-width: 1000px) {
                .schedule {
                    display: grid;
                    grid-template-columns: repeat(1, 1fr);
                    gap: 3rem;
                    padding: 0rem;
                    flex-flow: column;
                }

                .date-selection-inner-container {
                    flex-direction: column;
                    align-items: start;
                    gap: 6px;
                }

                .exercise-class-container {
                    margin-bottom: 1rem;
                }
            }

            .filter-button {
                padding: 6px;
                background-color: #fefefe;
                color: #333;
                border-radius: 6px;
                display: flex;
                flex-direction: row;
                white-space: nowrap;
                gap: 6px;
                border: 1px solid #fff;
                box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
                font-size: 14px;
                text-align: center;
                align-items: end;
                justify-content: center;
            }

            @media only screen and (max-width: 700px) {
                .date-selection-container {
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 1rem;
                    flex-direction: column;
                    display: flex;
                    grid-template-columns: auto;
                    gap: 1rem;
                    padding: 0;
                    width: 100%;
                }

                .options-container {
                    flex-direction: row;
                    justify-content: space-between;
                    width: 100%;
                }

                .toggle-button-container {
                    width: 100%;
                    flex-direction: column-reverse;
                    display: flex;
                    gap: 1rem;
                }

                .date-selection-inner-container {
                    width: 100%;
                }
            }

            @media only screen and (min-width: 1000px) and (max-width: 1500px) {
                .schedule {
                    grid-template-columns: repeat(3, 1fr);
                    flex-flow: wrap;
                    gap: 3rem 1rem;
                }
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this._onConnectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._onDisconnectedCallback();
    }
    _onConnectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateComplete;
            this._setMaxWidthOnPortalClassesView();
            window.addEventListener('resize', () => {
                this._sizeHandler();
            });
            this._sizeHandler();
            this._loadDepartments();
        });
    }
    _onDisconnectedCallback() {
        this.dispatch(BoostPortalStore.Actions.SetShowCollapseForClassesMenu(false));
    }
    /** @override */ render() {
        return html `
            <boost-portal-header
                ?view-login-button="${false}"
                ?view-hide-info-button="${true}"
                ?hide-header-information="${this.hideHeaderInformation}"
                @toggle-hide-info="${(event) => this._toggleInfoVisibility(event)}"
            >
            </boost-portal-header>
            <vaadin-popover
                for="filter-button"
                modal
                content-width="340px"
                position="bottom"
                .opened="${this.popoverOpened}"
                @closed="${() => (this.popoverOpened = false)}"
                ${popoverRenderer(this.filterRenderer, [this.portalClasses])}
            ></vaadin-popover>
            <div class="date-selection-container">
                <div></div>
                ${this.isMobileView
            ? html ` <div class="date-selection-inner-container">
                              ${this._showFilterAndDepartmentView()}
                          </div>
                          <div class="options-container">${this._renderDateSelection()}</div>`
            : html `<div class="options-container">${this._renderDateSelection()}</div>
                          <div class="date-selection-inner-container">
                              ${this._showFilterAndDepartmentView()}
                          </div>`}
            </div>
            <div class="exercise-class-container">
                <div class="schedule">${this._renderWeekDays()}</div>
            </div>
        `;
    }
    filterRenderer() {
        const uniqueClassesForFilter = this.getUniqueClassesForFilter();
        return html `
            <vaadin-list-box
                .selectedValues="${this.selectedFilters.map((_, index) => uniqueClassesForFilter.findIndex((item) => item.value === this.selectedFilters[index].value))}"
                multiple
            >
                ${uniqueClassesForFilter.map((classItem) => html ` <vaadin-item @click="${() => this._filterChanged(classItem)}">
                            ${classItem.title}
                        </vaadin-item>`)}
            </vaadin-list-box>
        `;
    }
    getUniqueClassesForFilter() {
        const filterClasses = this.portalClasses.map((classes) => {
            var _a, _b;
            return ({
                value: (_a = classes.gren) !== null && _a !== void 0 ? _a : 0,
                title: (_b = classes.grennavn) !== null && _b !== void 0 ? _b : '',
            });
        });
        const uniqueTitles = Array.from(new Map(filterClasses.map((classes) => [classes.title, classes])).values());
        return uniqueTitles;
    }
    _toggleInfoVisibility(event) {
        this.hideHeaderInformation = event.detail.hideHeaderInformation;
        this._saveSelectionToLocalStorage();
    }
    _showFilterAndDepartmentView() {
        if (this.hideHeaderInformation) {
            return nothing;
        }
        return html ` ${this.portalClasses.length && !this.isMobileView
            ? html `<div style="display: flex; flex-direction: column;">
                      <cerum-form-label>${this.boostTranslate('filter-on-category')}</cerum-form-label>
                      <div class="property-container">${this._renderClassesFilter()}</div>
                  </div>`
            : nothing}

            <vaadin-select
                .value="${this.selectedDepartmentId ? String(this.selectedDepartmentId) : ''}"
                label="${this.boostTranslate('choose-department')}"
                ?disabled="${this.isLoading}"
                @value-changed="${(event) => this._onDepartmentChanged(event)}"
                .renderer="${vaadinSelectRendererCallbackWrapper(this._departmentRenderer())}"
            ></vaadin-select>`;
    }
    _onDepartmentChanged(event) {
        if (event.detail.value === '-1') {
            this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(undefined));
            BoostPortalParamsHandler.removeParameter('departmentId');
            return;
        }
        this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(Number(event.detail.value)));
        this.updateQueryParam('departmentId', Number(event.detail.value));
        this._saveSelectionToLocalStorage();
    }
    updateQueryParam(key, value) {
        if (!value) {
            return;
        }
        const url = new URL(window.location.href);
        url.searchParams.set(key, value.toString());
        window.history.pushState({}, '', url.toString());
    }
    _departmentRenderer() {
        return html `
            <vaadin-item value="-1">Ingen avdeling</vaadin-item>
            ${this.availableDepartments.map((department) => {
            var _a;
            return html `
                    <vaadin-item .value="${String(department.id)}">${(_a = department.navn) !== null && _a !== void 0 ? _a : ''}</vaadin-item>
                `;
        })}
        `;
    }
    _sizeHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            const width = window.innerWidth;
            yield this.updateComplete;
            if (width < 1400 || /Mobi|Android/i.test(navigator.userAgent)) {
                this.isMobileView = true;
            }
            else {
                this.isMobileView = false;
            }
        });
    }
    _isSelectedFilter(filter) {
        return this.selectedFilters.find((selectedFilters) => filter === selectedFilters.value);
    }
    _filterChanged(classItem) {
        if (this._isSelectedFilter(classItem.value)) {
            this.selectedFilters = this.selectedFilters.filter((selectedFilters) => selectedFilters.value !== classItem.value);
        }
        else {
            this.selectedFilters.push({ title: classItem.title, value: classItem.value });
        }
        this._saveSelectionToLocalStorage();
        this.requestUpdate('selectedFilters');
        this._aggregateClasses();
    }
    _renderClassesFilter() {
        const uniqueClassesForFilter = this.getUniqueClassesForFilter();
        return uniqueClassesForFilter.map((classes) => {
            return html `<div class="filter-badge">
                <cerum-item-tag
                    @click="${() => this._filterChanged(classes)}"
                    itemType="${CerumItemTagType.INFO}"
                    .selected="${Boolean(this._isSelectedFilter(classes.value))}"
                >
                    ${classes.title}
                </cerum-item-tag>
            </div>`;
        });
    }
    _renderDateSelection() {
        return html `
            <div style="display: flex; gap: 6px;">
                ${!this._isCurrentWeek()
            ? html `
                          ${!this.hideHeaderInformation
                ? html `<boost-button
                                    type="navigation"
                                    name="${this.boostTranslate('last-week')}"
                                    @click="${() => this._onDateChange(this.currentMoment.clone().subtract(1, 'week'))}"
                                ></boost-button>`
                : nothing}
                      `
            : nothing}

                <boost-button
                    type="navigation"
                    name="${this.boostTranslate('week')} ${this.currentMoment.isoWeek()}"
                    title="${this.boostTranslate('navigate-to-next-week')}"
                    @click="${() => this._onDateChange(moment())}"
                ></boost-button>

                ${this.hideHeaderInformation
            ? nothing
            : html ` <boost-button
                          type="navigation"
                          name="${this.boostTranslate('next-week')}"
                          @click="${() => this._onDateChange(this.currentMoment.clone().add(1, 'week'))}"
                      ></boost-button>`}
            </div>
            ${this.isMobileView && !this.hideHeaderInformation
            ? html `<div
                      id="filter-button"
                      class="filter-button"
                      @click="${() => this._onFilterButtonClick()}"
                  >
                      Filter
                      <cerum-icon
                          icon="vaadin:filter"
                          style="--cerum-icon-width: 14px;--cerum-icon-height: 14px;"
                      ></cerum-icon>
                  </div>`
            : nothing}
        `;
    }
    _onFilterButtonClick() {
        var _a;
        const popover = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('vaadin-popover');
        if (!popover) {
            return;
        }
        const forId = `filter-button`;
        if (popover.opened && popover.for === forId) {
            this._clearPopover(popover);
        }
        else {
            this._clearPopover(popover);
            requestAnimationFrame(() => {
                popover.for = forId;
                popover.opened = true;
            });
        }
    }
    _clearPopover(popover) {
        popover.opened = false;
        popover.for = '';
    }
    _onDateChange(newDate) {
        this.currentMoment = newDate;
    }
    _doPortalClassesLoad() {
        if (!this.token) {
            return;
        }
        if (this.loadClassesTimeout) {
            clearTimeout(this.loadClassesTimeout);
        }
        this.loadClassesTimeout = setTimeout(() => {
            this._loadPortalClasses();
        }, 300);
    }
    _loadPortalClasses() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            const loadClassesQuery = {
                from_date: this.currentMoment.clone().startOf('isoWeek').format('YYYY-MM-DD'),
                to_date: this.currentMoment.clone().endOf('isoWeek').format('YYYY-MM-DD'),
            };
            if (this.selectedDepartmentId) {
                loadClassesQuery.department_id = this.selectedDepartmentId;
            }
            const portalClassesRequestResult = yield MembersignupAPI.getV1BoostsignupClasses(loadClassesQuery);
            this.isLoading = false;
            if (isErrorHTTP(portalClassesRequestResult)) {
                SnackBar.pushError(portalClassesRequestResult.error);
                return;
            }
            this.portalClasses = portalClassesRequestResult;
        });
    }
    _filterClassesBySelectedFilter() {
        if (!this.selectedFilters.length) {
            return this.portalClasses;
        }
        let filteredPortalClasses = this.portalClasses.filter((portalClass) => this.selectedFilters.find((findPortalClass) => findPortalClass.value === portalClass.gren));
        if (this.selectedDepartmentId) {
            filteredPortalClasses = filteredPortalClasses.filter((portalClass) => portalClass.avdeling === this.selectedDepartmentId);
        }
        return filteredPortalClasses;
    }
    _renderWeekDays() {
        return html `
            ${this.daysOfWeek.map((dayOfWeek) => {
            return this._renderWeekDay(dayOfWeek, dayOfWeek.groupedClasses);
        })}
        `;
    }
    _renderWeekDay(dayOfWeek, relevantClassesForDay) {
        const weekdayMoment = this.currentMoment.isoWeekday(dayOfWeek.day);
        const formattedDate = weekdayMoment.format('DD.MM');
        return html `
            <div class="day-column">
                <div class="day-header">
                    ${this._translateDay(dayOfWeek.day)}
                    <small>(${formattedDate})</small>
                </div>

                ${this.isLoading
            ? html `<div class="class-card">
                          <cerum-loading style="--loading-container-width: 200px;"></cerum-loading>
                      </div>`
            : html `${this._renderClassesForDay(relevantClassesForDay)}`}
            </div>
        `;
    }
    _translateDay(day) {
        return this.boostTranslate(day);
    }
    _renderClassesForDay(relevantClassesForDay) {
        if (!relevantClassesForDay.length) {
            return html `<boost-status-container type="info">
                ${!this.selectedDepartmentId
                ? this.boostTranslate('choose-department')
                : this.boostTranslate('no-classes')}
            </boost-status-container>`;
        }
        return relevantClassesForDay.map((relevantPortalClass) => this._renderCard(relevantPortalClass));
    }
    _filterClassesForDay(dayOfWeek, filterClasses) {
        if (!filterClasses.length) {
            return [];
        }
        return filterClasses.filter((portalClass) => {
            if (!portalClass.dato) {
                return false;
            }
            const portalClassDate = moment.unix(portalClass.dato);
            return (portalClassDate.isSameOrBefore(this.currentMoment.endOf('isoWeek'), 'date') &&
                portalClassDate.isSameOrAfter(this.currentMoment.startOf('isoWeek'), 'date') &&
                dayOfWeek.day.toLowerCase() === portalClassDate.format('dddd').toLowerCase());
        });
    }
    _renderCard(portalClass) {
        const cardClassColor = portalClass.classes[0].color;
        return html `
            <div class="class-card" style="${styleMap({ borderLeft: '6px solid ' + cardClassColor })}">
                <div class="class-title">
                    <p style="font-size:18px; margin:0; text-wrap:auto">${portalClass.name}</p>
                    <p style="margin:0; font-size: 15px;">
                        ${portalClass.startTime} - ${portalClass.endTime}
                    </p>
                </div>

                <div class="class-details">
                    ${portalClass.instructor
            ? html `<span>${this.boostTranslate('instructor')} ${portalClass.instructor}</span>`
            : nothing}
                    <div style="display: flex; gap: 6px 3px; flex-wrap: wrap; margin-top: 6px;">
                        ${portalClass.classes.map((portalClass) => html `<cerum-item-tag
                                    style="--item-tag-padding: 3px;"
                                    itemType="${CerumItemTagType.INFO}"
                                    title="Varighet: ${portalClass.varighet} minutter"
                                >
                                    ${portalClass.tidspunkt}
                                </cerum-item-tag>`)}
                    </div>
                </div>
            </div>
        `;
    }
    _isCurrentWeek() {
        const currentWeek = moment().isoWeek();
        return this.currentMoment.isoWeek() === currentWeek;
    }
    _setMaxWidthOnPortalClassesView() {
        this.dispatch(BoostPortalStore.Actions.SetPortalMaxWidth(2000));
    }
    _isMobileViewObserver() {
        this.dispatchEvent(new CustomEvent('screen-size-changed', {
            detail: { value: this.isMobileView },
            bubbles: true,
            composed: true,
        }));
        this.dispatch(BoostPortalStore.Actions.SetShowCollapseForClassesMenu(this.isMobileView));
    }
    _aggregateClasses() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const filteredClasses = this._filterClassesBySelectedFilter();
        for (const dayOfWeek of this.daysOfWeek) {
            const relevantClassesForDay = this._filterClassesForDay(dayOfWeek, filteredClasses);
            const classesByTitle = new Map();
            for (const portalClass of relevantClassesForDay) {
                const titleKey = (_a = portalClass.tittel) !== null && _a !== void 0 ? _a : this.boostTranslate('no-name');
                if (!classesByTitle.has(titleKey)) {
                    classesByTitle.set(titleKey, []);
                }
                let classesByTitleKey = classesByTitle.get(titleKey);
                if (!classesByTitleKey) {
                    classesByTitleKey = [];
                    classesByTitle.set(titleKey, []);
                }
                classesByTitleKey.push(portalClass);
            }
            const summarized = [];
            for (const [titleKey, classGroup] of classesByTitle.entries()) {
                if (classGroup.length > 5) {
                    const timestamps = classGroup.map((portalClass) => { var _a; return moment.unix((_a = portalClass.booking_starts_at) !== null && _a !== void 0 ? _a : 0); });
                    const startTimestamp = moment.min(timestamps);
                    let endTimestamp = moment.max(timestamps);
                    if (classGroup.length === 1 &&
                        startTimestamp.format('HH:mm') === endTimestamp.format('HH:mm')) {
                        endTimestamp = endTimestamp.clone().add((_b = classGroup[0].varighet) !== null && _b !== void 0 ? _b : 0, 'minutes');
                    }
                    const first = classGroup[0];
                    summarized.push({
                        name: (_c = first.grennavn) !== null && _c !== void 0 ? _c : titleKey,
                        instructor: (_d = first.instructor) !== null && _d !== void 0 ? _d : '',
                        color: (_e = first.color) !== null && _e !== void 0 ? _e : '',
                        startTime: startTimestamp.format('HH:mm'),
                        endTime: endTimestamp.format('HH:mm'),
                        classes: classGroup,
                    });
                }
                else {
                    for (const portalClass of classGroup) {
                        const startOfClass = moment.unix((_f = portalClass.booking_starts_at) !== null && _f !== void 0 ? _f : 0);
                        const endOfClass = startOfClass.clone().add((_g = portalClass.varighet) !== null && _g !== void 0 ? _g : 0, 'minutes');
                        summarized.push({
                            name: (_h = portalClass.tittel) !== null && _h !== void 0 ? _h : this.boostTranslate('no-name'),
                            instructor: (_j = portalClass.instructor) !== null && _j !== void 0 ? _j : '',
                            color: (_k = portalClass.color) !== null && _k !== void 0 ? _k : '',
                            startTime: startOfClass.format('HH:mm'),
                            endTime: endOfClass.format('HH:mm'),
                            classes: [portalClass],
                        });
                    }
                }
            }
            summarized.sort((startTime, endTime) => {
                var _a, _b;
                return ((_a = startTime.classes[0].booking_starts_at) !== null && _a !== void 0 ? _a : 0) -
                    ((_b = endTime.classes[0].booking_starts_at) !== null && _b !== void 0 ? _b : 0);
            });
            dayOfWeek.groupedClasses = summarized;
        }
        this.requestUpdate('daysOfWeek');
    }
    _loadDepartments() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const departmentsResult = yield MembersignupAPI.getV1BoostsignupDepartments();
            if (isErrorHTTP(departmentsResult)) {
                SnackBar.pushError(departmentsResult.error);
                return;
            }
            const firstDepartmentId = (_a = departmentsResult.at(0)) === null || _a === void 0 ? void 0 : _a.id;
            if (departmentsResult.length === 1 && firstDepartmentId) {
                this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(firstDepartmentId));
                this.updateQueryParam('departmentId', firstDepartmentId);
            }
            this.dispatch(BoostPortalStore.Actions.SetDepartments(departmentsResult));
        });
    }
    _saveSelectionToLocalStorage() {
        if (this.saveSelectionLocallyTimeout) {
            clearTimeout(this.saveSelectionLocallyTimeout);
        }
        this.saveSelectionLocallyTimeout = setTimeout(() => {
            const settings = {
                currentMoment: this.currentMoment.format('YYYY-MM-DD'),
            };
            if (this.selectedDepartmentId) {
                settings.selectedDepartmentId = this.selectedDepartmentId;
            }
            if (this.selectedFilters.length) {
                settings.selectedFilters = this.selectedFilters;
            }
            if (this.hideHeaderInformation) {
                settings.hideInformation = this.hideHeaderInformation;
            }
            localStorage.setItem(`boost-portal-classes-settings-${this.centerShort}`, JSON.stringify(settings));
        }, 300);
    }
    _loadSelectionFromLocalStorage() {
        if (!this.centerShort) {
            return;
        }
        const settingsString = localStorage.getItem(`boost-portal-classes-settings-${this.centerShort}`);
        if (!settingsString) {
            return;
        }
        const settings = JSON.parse(settingsString);
        const momentDate = moment(settings.currentMoment, 'YYYY-MM-DD');
        if (!momentDate.isValid()) {
            localStorage.removeItem('boost-portal-classes-settings');
            return;
        }
        this.currentMoment = momentDate;
        const isValidDepartment = this.availableDepartments.find((dept) => dept.id === settings.selectedDepartmentId);
        if (settings.selectedDepartmentId && isValidDepartment) {
            this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(settings.selectedDepartmentId));
            this.updateQueryParam('departmentId', settings.selectedDepartmentId);
        }
        else if (!isValidDepartment) {
            BoostPortalParamsHandler.removeParameter('departmentId');
        }
        if (settings.selectedFilters) {
            this.selectedFilters = settings.selectedFilters;
        }
        if (settings.hideInformation) {
            this.hideHeaderInformation = settings.hideInformation;
        }
        this._hasLoadedSettings = true;
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'currentMoment':
                case 'token':
                    this._doPortalClassesLoad();
                    break;
                case 'portalClasses':
                    this._aggregateClasses();
                    break;
                case 'isMobileView':
                    this._isMobileViewObserver();
                    break;
                case 'availableDepartments':
                    if (!this._hasLoadedSettings) {
                        this._loadSelectionFromLocalStorage();
                    }
                    break;
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalClassesView._deps = [
    BoostPortalHeader,
    BoostButton,
    CerumLoading,
    BoostPortalChooseDepartment,
    CerumItemTag,
    Popover,
];
__decorate([
    reduxBind(BoostPortalStore.path('portalMaxWidth')),
    state(),
    __metadata("design:type", Number)
], BoostPortalClassesView.prototype, "portalMaxWidth", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalClassesView.prototype, "centerShort", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalClassesView.prototype, "currentMoment", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], BoostPortalClassesView.prototype, "portalClasses", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalClassesView.prototype, "isLoading", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], BoostPortalClassesView.prototype, "selectedFilters", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalClassesView.prototype, "isMobileView", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('departments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalClassesView.prototype, "availableDepartments", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalClassesView.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('token')),
    state(),
    __metadata("design:type", String)
], BoostPortalClassesView.prototype, "token", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalClassesView.prototype, "hideHeaderInformation", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalClassesView.prototype, "popoverOpened", void 0);
__decorate([
    state(),
    __metadata("design:type", void 0)
], BoostPortalClassesView.prototype, "loadClassesTimeout", void 0);
__decorate([
    state(),
    __metadata("design:type", void 0)
], BoostPortalClassesView.prototype, "saveSelectionLocallyTimeout", void 0);
BoostPortalClassesView = __decorate([
    customElement(BoostPortalClassesView.is)
], BoostPortalClassesView);
export { BoostPortalClassesView };
